const initialState = {
    isEdit: false,
  };
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_IS_EDIT':
        return {
          ...state,
          isEdit: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default authReducer;
  
  
  